import { borderColorVariants } from '../css/formElement.css';
export const getBorderStyles = (isFrozen, hasError, hasWarning) => {
    if (isFrozen) {
        return borderColorVariants.frozen;
    }
    if (hasError) {
        return borderColorVariants.error;
    }
    return hasWarning ? borderColorVariants.warning : borderColorVariants.default;
};
